// extracted by css-extract-rspack-plugin
export default {"formContainer":"VdBC9FJUaSULyh3w","contentContainer":"TIhG1QCFMlElDQy3","mobileFormContainer":"wLc0xK73wYkqjlcV","mobileContentContainer":"KdwO2OB4QU7egHPN"};